import * as React from 'react';
import { ICON_SIZE_MAP } from '../helpers/size.js';
const TagIcon = React.forwardRef((props, ref) => {
    const sizeKey = props.size !== undefined ? props.size : 1;
    const size = ICON_SIZE_MAP[sizeKey];
    return (React.createElement("svg", { width: size, height: size, fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, viewBox: "0 0 16 16" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m7.7.3 8 8c.4.4.4 1 0 1.4l-6 6c-.2.2-.4.3-.7.3-.3 0-.5-.1-.7-.3l-8-8C.1 7.5 0 7.3 0 7V1c0-.6.4-1 1-1h6c.3 0 .5.1.7.3ZM2 6.6l7 7L13.6 9l-7-7H2v4.6ZM6 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z", fill: "currentColor" })));
});
TagIcon.displayName = 'TagIcon';
export default TagIcon;
